import styled from 'styled-components';

export const PaperStyled = styled.div<{ narrow?: boolean }>`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  flex-grow: 1;
  background-color: #fff;
  border: 1px solid #dfe0eb;
  box-shadow: none;
  padding: ${({ narrow }) => (narrow ? '8px 10px' : '15px 25px')};
  border-radius: 8px;
  align-content: start;
  grid-auto-rows: max-content max-content 1fr;
  h5 {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 19px;
    line-height: 26px;
    font-weight: 600;
  }
`;

export const Title = styled.h3`
  margin: -1rem 0 24px;
  color: #252733;
  font-size: 19px;
  font-weight: 600;
`;

export const ButtonsGroup = styled.div`
  display: flex;
  justify-content: center;
  button {
    width: auto;
    margin: 0 8px;
  }
  .MuiSkeleton-root {
    margin: 0 1rem;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  line-height: 20px;
  font-size: 14px;
  margin-right: 20px;
  .title {
    flex-shrink: 0;
    width: 220px;
  }
  .value {
    flex-grow: 1;
    .MuiSkeleton-root {
      max-width: 280px;
    }
  }
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 25px;
  .title {
    flex-shrink: 0;
    width: 140px;
    margin-right: 10px;
    color: #252733;
    font-weight: 600;
  }
  .value {
    color: #9fa2b4;
  }
`;

export const RejectDialogWrapper = styled.div`
  width: 560px;
  display: grid;
  padding: 0 28px 22px;
  grid-gap: 5px;
  p {
    margin: 0;
    font-size: 14px;
    line-height: 24px;
  }
  .MuiFormControl-root {
    width: 100%;
  }
  .MuiOutlinedInput-multiline {
    background-color: #f5f6f8;
  }
`;
